import firebase from '../../firebase';

export default async function conciliateRidePayment(params) {
    return firebase.functions().httpsCallable('rides-conciliatePayments')(params);
}
